import { FC, useMemo } from "react";

import { EditBlock, IEditBlockItem } from "shared/components";
import { copy } from "shared/assets";
import { AtIcon, IdCard, Megaphone, User, Weight } from "shared/assets/icons";
import { useProfileRoute } from "Bands/utils";
import { BAND_PATHS } from "Bands/router";
import { ILocalStorageKey } from "shared/types";

const helpBlockCopy = copy.profile.helpBlock;

export const HelpBlock: FC = () => {
  const { getPath } = useProfileRoute();

  const items: IEditBlockItem[] = useMemo(
    () => [
      {
        icon: User,
        label: helpBlockCopy.personalDetails.link,
        subLabel: helpBlockCopy.personalDetails.text,
        to: getPath(BAND_PATHS.EDIT_PROFILE),
      },
      {
        icon: AtIcon,
        label: helpBlockCopy.contactDetails.link,
        subLabel: helpBlockCopy.contactDetails.text,
        to: getPath(BAND_PATHS.EDIT_PROFILE_CONTACT),
      },
      {
        icon: IdCard,
        label: helpBlockCopy.documents.link,
        subLabel: helpBlockCopy.documents.text,
        to: getPath(BAND_PATHS.EDIT_PROFILE_DOCUMENTS),
      },
      {
        icon: Weight,
        label: helpBlockCopy.preferences.link,
        subLabel: helpBlockCopy.preferences.text,
        to: getPath(BAND_PATHS.EDIT_PROFILE_PREFERENCES),
      },
    ],
    [getPath]
  );

  return (
    <EditBlock
      id="profile-help-block"
      cardTitle={helpBlockCopy.title}
      cardIcon={Megaphone}
      items={items}
      localStorageKey={ILocalStorageKey.profileHelpBlock}
    />
  );
};
